import { StateCreator } from 'zustand';
import { ITasksSlice } from './Interface';

export const tasksSlice: StateCreator<ITasksSlice> = (set) => ({
  isClaimed: false, // Initialize isClaimed property
  setIsClaimed: (isClaimed: boolean) => {
    set({ isClaimed });
  },
});